/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import NAV from "./nav";

import { ExternalLink, ArrowLeft } from "lucide-react";
import {fetchNews, fetchNewsArticle} from "../api";
import NewsHero from "../components/news/NewsHero";
import NewsTicker from "../components/news/NewsTicker";
import PriceScroller from "../components/pricescroll_ver_2";

export default function NewsArticlePage() {

    const { id } = useParams();

    const [article, setArticle] = useState(null);

    useEffect(() => {

        // fetch(`http://127.0.0.1:8000/api/news/${id}/`)
        //     .then((res) => res.json())
        //     .then((data) => {
        //         setArticle(data);
        //     });
        fetchNewsArticle(id).then((data) => {
            setArticle(data);
        });

    }, [id]);

    if (!article) {

        return (

            <div className="
                min-h-screen
                bg-zinc-950
                text-white
            ">

                <NAV activetag="news" />

                <div className="p-10">
                    Loading article...
                </div>

            </div>
        );
    }

    return (

        <div className="
            min-h-screen
            bg-zinc-950
            text-white
        ">

            <NAV activetag="news" />
            {/* Market Ribbon */}


            {/* Hero Section */}

            <NewsHero />
        <PriceScroller/>
            <div className="
                max-w-4xl
                mx-auto
                px-6
                py-10
            ">

                {/* Back Button */}

                <button
                    onClick={() => window.history.back()}
                    className="
                        flex
                        items-center
                        gap-2
                        text-zinc-400
                        hover:text-emerald-400
                        transition-colors
                        mb-8
                    "
                >

                    <ArrowLeft size={18} />

                    Back to News

                </button>

                {/* Category */}

                <div className="
                    inline-flex
                    items-center
                    px-3
                    py-1
                    rounded-full
                    bg-emerald-500/10
                    text-emerald-400
                    text-xs
                    font-semibold
                    tracking-wide
                    mb-6
                ">

                    MARKET NEWS

                </div>

                {/* Title */}

                <h1 className="
                    text-4xl
                    lg:text-5xl
                    font-black
                    text-white
                    leading-tight
                    mb-6
                ">

                    {article.title}

                </h1>

                {/* Meta */}

                <div className="
                    flex
                    items-center
                    gap-4
                    text-zinc-500
                    text-sm
                    mb-10
                    border-b
                    border-zinc-800
                    pb-6
                ">

                    <span>{article.date}</span>

                    <span>•</span>

                    <span>Orion Analytics</span>

                </div>

                {/* Description */}

                <div className="
                    text-zinc-300
                    text-lg
                    leading-relaxed
                    space-y-6
                ">

                    <p>
                        {article.description}
                    </p>

                    <p className="text-zinc-500 italic">
                        Full article integration and AI summaries
                        coming soon in Orion Analytics.
                    </p>

                </div>

                {/* Source Button */}

                <div className="mt-12">

                    <a
                        href={article.url}
                        target="_blank"
                        rel="noreferrer"
                        className="
                            inline-flex
                            items-center
                            gap-2
                            px-5
                            py-3
                            rounded-xl
                            bg-emerald-500
                            text-black
                            font-semibold
                            hover:bg-emerald-400
                            transition-colors
                        "
                    >

                        Read Original Source

                        <ExternalLink size={18} />

                    </a>

                </div>

            </div>

        </div>
    );
}